//
import ProductModel from '@/models/Warehouse/WhProduct'

//
import ProductAppends from './ProductAppends'
import ProductIncludes from './ProductIncludes'

/**
 *
 */
const fetchByWh = async ( id_warehouse ) => {
    //
    try {
        //
        const response = await ProductModel.append( ProductAppends ).include( ProductIncludes ).where('of_warehouse', id_warehouse)
        // - http://.../api/wh_product?filter[of_warehouse]=1&bypass
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchByWh
